// Формата „Работно време" — чиста логика без React: седмицата по
// подразбиране, изборът на часове и валидацията (огледало на BE
// `schemas_working_hours.py` — BE е източникът на истината, тук е само за да
// не тръгва заявка, която ще върне 422).

import type { WorkingDay } from "../../../../api/configuration";
import { crossesMidnight, minutesOfTime } from "../../../../lib/workingHours";

export const DAYS_IN_WEEK = 7;
// Стъпката е 15 минути — като слотовете на резервациите.
const STEP_MINUTES = 15;

const pad = (value: number) => String(value).padStart(2, "0");

/** Всички часове за избор: 00:00, 00:15 … 23:45. */
export const TIME_OPTIONS: string[] = Array.from(
  { length: (24 * 60) / STEP_MINUTES },
  (_, index) => {
    const minutes = index * STEP_MINUTES;
    return `${pad(Math.floor(minutes / 60))}:${pad(minutes % 60)}`;
  },
);

/**
 * Седмицата, с която се отваря формата, докато нищо не е записано: всеки ден
 * 11:00–23:00 — резервациите приемат същите часове като преди настройката
 * (11:00–22:45).
 */
export const DEFAULT_WEEK: WorkingDay[] = Array.from({ length: DAYS_IN_WEEK }, () => ({
  closed: false,
  opensAt: "11:00",
  closesAt: "23:00",
}));

/** Грешката на деня (ключ в `workingHours.errors`); null — денят е валиден. */
export type WorkingDayError = "sameTime" | "overlapsNextDay" | null;

/** Огледало на `WorkingHoursIn._check_days` в BE. */
export const workingDayErrorOf = (week: WorkingDay[], index: number): WorkingDayError => {
  const day = week[index];
  if (day.closed) return null;
  if (day.opensAt === day.closesAt) return "sameTime";
  const nextDay = week[(index + 1) % DAYS_IN_WEEK];
  if (
    crossesMidnight(day) &&
    !nextDay.closed &&
    minutesOfTime(day.closesAt) >= minutesOfTime(nextDay.opensAt)
  ) {
    return "overlapsNextDay";
  }
  return null;
};

export const isWeekValid = (week: WorkingDay[]) =>
  week.every((_, index) => workingDayErrorOf(week, index) === null);

export const isSameWeek = (left: WorkingDay[], right: WorkingDay[]) =>
  left.every(
    (day, index) =>
      day.closed === right[index].closed &&
      day.opensAt === right[index].opensAt &&
      day.closesAt === right[index].closesAt,
  );
